import { createFileRoute } from '@tanstack/react-router';

import { buildBreadcrumbSchema, buildSeoHead, buildWebPageSchema, jsonLdScript, ROUTE_META } from '@src/corelib/seo';

export const Route = createFileRoute('/platform/pentest')({
  head: () => ({
    ...buildSeoHead({ path: '/platform/pentest', ...ROUTE_META['/platform/pentest'] }),
    scripts: [
      jsonLdScript(buildBreadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Pentest', path: '/platform/pentest' }])),
      jsonLdScript(buildWebPageSchema({ path: '/platform/pentest', ...ROUTE_META['/platform/pentest'] })),
    ],
  }),
});
